export default {"src":"/_next/static/media/window-specialty.7da1ac48.svg","height":1000,"width":1000};